import React from 'react';
import { useParams } from 'react-router-dom';
import Title from '../Title.jsx';
import { useTranslation } from 'react-i18next';

const ProductDescription = () => {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();

  const productPageObj = i18n.getResource(
    i18n.language,
    'translation',
    'product_page'
  );

  const productKey = Object.keys(productPageObj).find(
    (key) => productPageObj[key].slug === slug
  );

  if (!productKey) {
    return <div>Product not found</div>;
  }

  return (
    <div className='flex flex-col items-center p-6 md:p-12 gap-6 md:gap-12'>
      <div className='flex flex-col gap-4'>
        <Title>{t(`product_page.${productKey}.product_page_title`)}</Title>
      </div>
      <div className='flex flex-col lg:flex-row gap-6 lg:gap-12 max-w-6xl'>
        <div className='text-center text-lg lg:text-xl font-light leading-8 text-primary-blue'>
          <div>{t(`product_page.${productKey}.product_page_description`)}</div>
        </div>
      </div>
    </div>
  );
};

export default ProductDescription;
